/* Trace — mobile hero gallery enhancer.
   Mobile only: hide thumbnails, show floating pagination dots inside the image,
   and OPTIONAL autoplay controlled by the product section settings
   (data-trace-autoplay / data-trace-autoplay-seconds on <media-gallery>).
   Drives Dawn's native scroll-snap gallery slider so state stays in sync. */
(function () {
  function init() {
    if (window.matchMedia('(min-width: 750px)').matches) return;

    var gallery = document.querySelector('media-gallery');
    if (!gallery) return;

    var viewer = gallery.querySelector('slider-component[id^="GalleryViewer"]') ||
                 gallery.querySelector('slider-component');
    var ul = gallery.querySelector('ul[id^="Slider-Gallery"]') ||
             gallery.querySelector('ul.product__media-list');
    if (!viewer || !ul) return;
    if (viewer.dataset.dzDots) return;

    var slides = ul.querySelectorAll('li.product__media-item');
    if (slides.length < 2) return;

    viewer.dataset.dzDots = '1';
    viewer.classList.add('dz-gallery');

    /* config from section settings */
    var autoplay = gallery.dataset.traceAutoplay === 'true';
    var seconds = parseInt(gallery.dataset.traceAutoplaySeconds, 10);
    if (!seconds || seconds < 2) seconds = 7;

    function base() { return slides[0].offsetLeft; }

    function curIndex() {
      var b = base(), sl = ul.scrollLeft, best = 0, bd = Infinity;
      for (var i = 0; i < slides.length; i++) {
        var d = Math.abs((slides[i].offsetLeft - b) - sl);
        if (d < bd) { bd = d; best = i; }
      }
      return best;
    }

    function scrollTo(i) {
      ul.scrollTo({ left: slides[i].offsetLeft - base(), behavior: 'smooth' });
    }

    function go(dir) {
      var n = slides.length;
      scrollTo((curIndex() + dir + n) % n);
    }

    /* autoplay (optional) */
    var timer = null, resumeT = null;
    function tick() { if (!document.hidden) go(1); }
    function play() { if (!autoplay) return; clearInterval(timer); timer = setInterval(tick, seconds * 1000); }
    function pause() { clearInterval(timer); }
    function resume() { if (!autoplay) return; clearTimeout(resumeT); resumeT = setTimeout(play, Math.max(6000, seconds * 1000)); }

    /* build dots */
    var nav = document.createElement('div');
    nav.className = 'dz-dots';
    var dots = [];
    for (var i = 0; i < slides.length; i++) {
      (function (idx) {
        var d = document.createElement('button');
        d.type = 'button';
        d.className = 'dz-dot';
        d.setAttribute('aria-label', 'Go to image ' + (idx + 1));
        d.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          pause();
          scrollTo(idx);
          resume();
        });
        nav.appendChild(d);
        dots.push(d);
      })(i);
    }
    viewer.appendChild(nav);

    function setActive(i) {
      for (var j = 0; j < dots.length; j++) {
        dots[j].classList.toggle('is-active', j === i);
      }
    }
    setActive(curIndex());

    /* keep dots in sync while the native slider scrolls (swipe / dot tap / autoplay) */
    var raf = null;
    ul.addEventListener('scroll', function () {
      if (raf) return;
      raf = requestAnimationFrame(function () { raf = null; setActive(curIndex()); });
    }, { passive: true });

    if (autoplay) {
      ul.addEventListener('touchstart', function () { pause(); resume(); }, { passive: true });
      play();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
